import styled from "styled-components";

export const FileReportStyles = styled.div`
  width: fit-content;
  cursor: pointer;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;

  > p {
    color: #0f81d9;
    text-align: center;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;
